import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$slug/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$slug/settings/contacts', params: { slug: params.slug } })
  },
})
